import en from './en.js';
import fr from './fr.js';

export default { ...en, ...fr };